@if (isLoading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (lprLog) {
<div id="lpr-log-details-container">
  <!-- Header Toolbar -->
  <mat-toolbar class="mat-elevation-z8 header py-1" id="lpr-log-details-toolbar">
    <div class="d-flex align-items-center flex-wrap">
      <span>LPR Log Details</span>
      <span class="text-secondary px-2"> / </span>
      <span class="me-3">{{ lprLog.definedData?.plateText }}</span>
      <app-status-badge [text]="lprLog.direction | titlecase" [isLprLogDirection]="true"></app-status-badge>
    </div>
    <div>
      <span>
        {{ lprLog.created | date: 'yyyy-MM-dd, ' }}
      </span>
      <span class="text-secondary">
        {{ lprLog.created | date: 'HH:mm' }}
      </span>
    </div>
  </mat-toolbar>
  <!-- Main Content -->
  <div class="container-fluid mt-4 mb-4">
    <div class="row">
      <!-- Images Section -->
      @if (lprLog.images && lprLog.images.length > 0) {
      <div class="col-lg-8">
        <mat-card class="images-card mb-4">
          <mat-card-header>
            <mat-card-title class="card-title-flex">
              <mat-icon class="me-2">image</mat-icon>
              Images ({{ lprLog.images.length }})
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Main Image Display -->
            <div class="main-image-container mb-3">
              @if (lprLog.images[selectedImageIndex]) {
              <div class="image-wrapper" (mousedown)="onDragStart($event)" (mousemove)="onDrag($event)"
                (mouseup)="onDragEnd()" (mouseleave)="onDragEnd()">
                <img
                  [src]="'data:image/' + lprLog.images[selectedImageIndex].format + ';base64,' + lprLog.images[selectedImageIndex].data"
                  alt="LPR Image" class="main-image"
                  [style.transform]="'scale(' + zoomLevel + ') translate(' + panX + 'px,' + panY + 'px)'"
                  [style.image-rendering]="'high-quality'"
                  [style.cursor]="zoomLevel > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'">
              </div>
              }
              <div class="image-controls">
                <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= 0.5">
                  <mat-icon>zoom_out</mat-icon>
                </button>
                <span class="zoom-level">{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
                <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= 3">
                  <mat-icon>zoom_in</mat-icon>
                </button>
                <button mat-icon-button (click)="resetZoom()" [disabled]="zoomLevel === 1">
                  <mat-icon>refresh</mat-icon>
                </button>
                <button mat-icon-button (click)="toggleFullscreen()">
                  <mat-icon>fullscreen</mat-icon>
                </button>
              </div>
            </div>
            <!-- Thumbnail Gallery -->
            <div class="thumbnails-container">
              <div class="thumbnails-scroll">
                @for (image of lprLog.images; track image; let i = $index) {
                <div class="thumbnail" [class.active]="selectedImageIndex === i" (click)="selectImage(i)">
                  <img [src]="'data:image/' + image.format + ';base64,' + image.data" alt="Thumbnail {{ i + 1 }}"
                    class="thumbnail-img">
                  <span class="thumbnail-number">{{ i + 1 }}</span>
                </div>
                }
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      }
      <!-- Details Section -->
      <div class="col-lg-4">
        <!-- Basic Information Card -->
        <mat-card class="details-card mb-4">
          <mat-card-header>
            <mat-card-title>
              <mat-icon class="me-2">info</mat-icon>
              Basic Information
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="details-row">
              <span class="details-label">License Plate:</span>
              <span class="details-value">
                {{ lprLog.definedData?.plateText }}
              </span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Direction:</span>
              <span class="details-value">{{ lprLog.direction | titlecase }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Created:</span>
              <span class="details-value">{{ lprLog.created | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Processing Time:</span>
              <span class="details-value">{{ lprLog.processingTimeMs }} ms</span>
            </div>
          </mat-card-content>
        </mat-card>
        <!-- Camera Information Card -->
        @if (lprLog.definedData) {
        <mat-card class="details-card mb-4">
          <mat-card-header>
            <mat-card-title>
              <mat-icon class="me-2">videocam</mat-icon>
              Camera Information
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="details-row">
              <span class="details-label">Serial Number:</span>
              <span class="details-value">{{ lprLog.definedData?.cameraSerialNumber }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">IP Address:</span>
              <span class="details-value">{{ lprLog.definedData?.cameraIPAddress }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Sensor ID:</span>
              <span class="details-value">{{ lprLog.definedData?.sensorProviderID }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Date Time:</span>
              <span class="details-value">{{ lprLog.definedData?.datetime }}</span>
            </div>
          </mat-card-content>
        </mat-card>
        }
        <!-- Action & Status Card -->
        <mat-card class="details-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon class="me-2">assignment</mat-icon>
              Action & Status
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="details-row">
              <span class="details-label">Action:</span>
              <span class="details-value">{{ lprLog.action }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Display Status:</span>
              <span class="details-value">
                {{ lprLog.displayStatus ? lprLog.displayStatus : '-' }}
              </span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Stage:</span>
              <span class="details-value">{{ lprLog.stage ? lprLog.stage : '-' }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Handled At:</span>
              <span class="details-value">{{ lprLog.handledAt ? (lprLog.handledAt | date: 'yyyy-MM-dd HH:mm:ss') : '-'
                }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <span class="details-label">Handled By Event ID:</span>
              <span class="details-value">{{ lprLog.handledByEventId ? lprLog.handledByEventId : '-' }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <!-- Fullscreen Modal -->
    @if (isFullscreen) {
    <div class="fullscreen-overlay" (click)="toggleFullscreen()">
      <div class="fullscreen-content" (click)="$event.stopPropagation()">
        <div class="fullscreen-controls">
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= 0.5">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= 3">
            <mat-icon>zoom_in</mat-icon>
          </button>
          <button mat-icon-button (click)="resetZoom()" [disabled]="zoomLevel === 1">
            <mat-icon>refresh</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleFullscreen()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="fullscreen-image-container" (mousedown)="onDragStart($event)" (mousemove)="onDrag($event)"
          (mouseup)="onDragEnd()" (mouseleave)="onDragEnd()">
          @if (lprLog?.images && lprLog.images[selectedImageIndex]) {
          <img
            [src]="'data:image/' + lprLog.images[selectedImageIndex].format + ';base64,' + lprLog.images[selectedImageIndex].data"
            alt="LPR Image Fullscreen"
            [style.transform]="'scale(' + zoomLevel + ') translate(' + panX + 'px,' + panY + 'px)'"
            [style.image-rendering]="'high-quality'"
            [style.cursor]="zoomLevel > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'">
          }
        </div>
        @if (lprLog?.images && lprLog.images.length > 1) {
        <div class="fullscreen-thumbnails">
          @for (image of lprLog.images; track image; let i = $index) {
          <div class="thumbnail" [class.active]="selectedImageIndex === i" (click)="selectImage(i)">
            <img [src]="'data:image/' + image.format + ';base64,' + image.data" alt="Thumbnail {{ i + 1 }}">
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
    <!-- Order Information Section (if available) -->
    @if (lprLog.orderId) {
    <div class="row mt-4">
      <div class="col-12">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="me-2">shopping_cart</mat-icon>
              Related Order Information
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="order-info-content p-3">
            <div class="info-grid">
              @if(lprLog?.orderId){
              <div class="info-item">
                <span class="info-label">Order ID:</span>
                <span class="info-value clickable-order-id" (click)="openOrderDetails(lprLog.orderId)">{{ lprLog.orderId
                  }}</span>
              </div>
              }
              @if(lprLog?.images?.[0]?.sessionId){
              <div class="info-item">
                <span class="info-label">Session ID:</span>
                <span class="info-value">{{ lprLog.images?.[0]?.sessionId }}</span>
              </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </div>
    }
    <!-- Display History Section (if available) -->
    @if (lprLog.displayHistory) {
    <div class="row mt-4">
      <div class="col-12">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="me-2">history</mat-icon>
              Display History
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="history-content p-3">
            @if (lprLog.displayHistory; as history) {
            <div class="details-row">
              <span class="details-label">ID:</span>
              <span class="details-value">{{ history.id }}</span>
            </div>
            <div class="details-row">
              <span class="details-label">Gate Display ID:</span>
              <span class="details-value">{{ history.gateDisplayId }}</span>
            </div>
            <div class="details-row">
              <span class="details-label">Status:</span>
              <span class="details-value">{{ history.status }}</span>
            </div>
            <div class="details-row">
              <span class="details-label">Created:</span>
              <span class="details-value">{{ history.created | date:'yyyy-MM-dd HH:mm:ss' }}</span>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="details-row">
              <!-- <span class="details-label">Message:</span> -->
              <span class="details-value">
                @if (history.message) {
                @for (item of (parseMessage(history.message) | keyvalue); track item) {
                <div class="details-row">
                  <span class="details-label">{{ item.key }}:</span>
                  <span class="details-value">{{ item.value ? item.value : '-' }}</span>
                </div>
                }
                }
              </span>
            </div>
            }
          </div>
        </mat-expansion-panel>
      </div>
    </div>
    }
  </div>
</div>
}

<!-- Empty State -->
@if (!isLoading && !lprLog) {
<div class="container mt-5">
  <mat-card class="empty-state">
    <mat-card-content>
      <mat-icon class="warning-icon">warning</mat-icon>
      <p>No LPR log data available. Please select a log from the list.</p>
      <button mat-raised-button color="primary" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Go Back
      </button>
    </mat-card-content>
  </mat-card>
</div>
}